import { trackElementClicked, trackUserEnteredInput } from '../analytics';
import { track } from './track';
import { page } from './page';
import camelize from '../string/camelize';
import forEachSelector from '../elements/forEachSelector';
import * as leadFormSelectors from '../elements/leadForm';
import * as stepModel from '../form_wizard/models/step';
import { processDataTrackingAttributes } from './data_attributes';

function getProperty(el, propertyName) {
  const matched = el.className.match(new RegExp(`js-${propertyName}:([^ ]+)`));
  return el.dataset[camelize(propertyName)] || (matched && matched[1]);
}

// keep track of the previous event in order not to accidentally track twice
let previousEvent;

function trackOnce(eventName, args) {
  // ensure we don't accidentally track this event twice within a couple of milliseconds
  // by storing a JSON representation of this event and args
  const argsJSON = `${eventName}:${JSON.stringify(args)}`;
  if (previousEvent === argsJSON) {
    return;
  }
  previousEvent = argsJSON;
  setTimeout(() => {
    if (previousEvent === argsJSON) {
      previousEvent = null;
    }
  }, 1);
  track(eventName, args);
}

// Handles Click/Submit Events
export function handleEvent(event) {
  const target = this.tagName;
  const className = this.className;
  const href = this.href;
  const leadFormId = leadFormSelectors.getLeadFormId(this);
  const panelId =
    leadFormSelectors.getLeadFormPanelId(this) || stepModel.getStepId(this);
  const text = (this.innerText || '').replace(/\s+/, ' ').trim();

  const eventName = getProperty(this, 'track') || event.type;
  const category = getProperty(this, 'category') || 'atlas';
  const dataAttributes = processDataTrackingAttributes(this);

  trackOnce(eventName, {
    className,
    target,
    href,
    text,
    category,
    leadFormId,
    panelId,
    dataAttributes,
  });

  trackElementClicked(event);
}

// Handles Scrolling Events
function handleScrollEvent(event) {
  if (document.body.scrollHeight > window.innerHeight) {
    let scrollPct = (
      window.scrollY /
      (document.body.scrollHeight - window.innerHeight)
    ).toFixed(2);
    const target = 'document';

    const eventName = event.type;
    const category = 'atlas';
    const label = 'scrollPct';
    const value = scrollPct;
    track(eventName, { target, category, label, value });
  }
}

function setupElement(el) {
  let eventName = getProperty(el, 'track-event');
  if (!eventName) {
    eventName = el.tagName.toLocaleLowerCase() === 'form' ? 'submit' : 'click';
  }
  el.addEventListener(eventName, handleEvent);
}

function handleBlurEvent(event) {
  const target = event.target.tagName;
  const className = event.target.className;
  const category = 'atlas';
  const eventName = event.type;
  const leadFormId = leadFormSelectors.getLeadFormId(event.target);
  const panelId =
    leadFormSelectors.getLeadFormPanelId(event.target) ||
    stepModel.getStepId(event.target);
  const fieldValue = event.target.value;
  const fieldName = event.target.name;

  track(eventName, {
    className,
    target,
    category,
    leadFormId,
    panelId,
    fieldValue,
    fieldName,
  });

  trackUserEnteredInput(event);
}

function setupBlurTracking(el) {
  el.addEventListener('blur', handleBlurEvent);
}

function trackPageLoad() {
  const target = 'page';
  const category = 'atlas';
  const eventName = 'loaded';

  track(eventName, { target, category });
  page({ category });
}

export function setup() {
  forEachSelector(
    '[class*="js-track"], [data-track],\
   button, label, a',
    setupElement
  );
  setupScrollTracking();
  forEachSelector('input:not([type="password"]),select', setupBlurTracking);
  trackPageLoad();
}

// Tracks scrolling events. We only want to track scroll events after scrolling has
// stopped for a set amount of time. Here we are tracking 200ms after the most recent scroll event
export function setupScrollTracking() {
  let isScrolling;
  document.addEventListener('scroll', (event) => {
    window.clearTimeout(isScrolling);

    isScrolling = setTimeout(function () {
      handleScrollEvent(event);
    }, 200);
  });
}
